import React from 'react';

import { PasswordInput } from 'components/shared/PasswordInput';

const PasswordField = ({
  field,
  form,
  ...restProps
}: { field: any; form: any } & Record<string, any>) => (
  <PasswordInput {...field} {...restProps} />
);

export default React.memo(PasswordField) as any;
